<template lang="pug">
div
  v-snackbar(v-model="snackbar.visivel"
    :color="snackbar.cor"
    :right="$vuetify.breakpoint.mdAndUp"
    :top="$vuetify.breakpoint.mdAndUp"
    :bottom="$vuetify.breakpoint.smAndDown"
    :multi-line="$vuetify.breakpoint.smAndDown"
    :timeout="snackbar.tempo"
  ) {{ snackbar.mensagem }}
    v-btn(dark text @click="snackbar.visivel = false") Fechar

  v-toolbar(dark color="red darken-1")
    v-btn(icon)
      v-avatar
        img(src="@/assets/logo.svg" alt="LogoCBMAP")
    
    v-toolbar-title(class="white--text") INTRANET

    v-spacer

    v-dialog(v-model="dialog" max-width="800")
      v-card(icons-and-text mobile-break-point)
        v-toolbar(flat dark color="red darken-1")
          v-toolbar-title Perfil do Usuário
        v-tabs(fixed-tabs show-arrows)
          v-tab
            v-icon(left) mdi-account
            span Informações Gerais
          v-tab
            v-icon(left) mdi-lock
            span Alterar Senha
          v-tab
            v-icon(left) mdi-email-edit
            span Alterar E-mail

          v-tab-item 
            v-container
              v-card(flat)
                p
                  strong Nome de guerra:
                  span &nbsp;{{ info.nome_guerra }}
                p 
                  strong CPF:
                  span &nbsp;{{ info.cpf }}
                p 
                  strong E-MAIL:
                  span &nbsp;{{ info.email }}
          v-tab-item 
            v-container
              v-card(flat)
                v-row
                  v-col(cols="12")
                    v-text-field(label="Senha Atual" type="password" v-model="senha_atual")
                v-row
                  v-col(cols="12")
                    v-text-field(label="Nova Senha" type="password" v-model="nova_senha")
                v-row
                  v-col(cols="12")
                    v-text-field(label="Confirmar Nova Senha" type="password" v-model="nova_senha_confirmation")
                v-row
                  v-col(cols="12")
                    v-btn(color="primary" @click="alterarSenha") Alterar
          v-tab-item
            v-container
              v-card(flat)
                v-row
                  v-col(cols="12")
                    v-text-field(label="E-mail Atual" v-model="antigo_email")
                v-row
                  v-col(cols="12")
                    v-text-field(label="Novo E-mail" v-model="novo_email")
                v-row
                  v-col(cols="12")
                    v-text-field(label="Confirmar Novo E-mail" v-model="novo_email_confirmation")
                v-row
                  v-col(cols="12")
                    v-btn(color="primary" @click="alterarEmail") Alterar

        v-divider
        v-card-actions
          v-spacer
          v-btn(color="primary" text @click="dialog = false") Fechar

    v-menu(v-model='menu' :close-on-content-click='false' :nudge-width='200' offset-x)
      template(v-slot:activator='{ on }')
        v-btn(icon v-on="on")
          v-icon mdi-dots-vertical
      v-card
        v-list
          v-list-item
            v-list-item-avatar
              img(src='@/assets/user_cbm.png', alt='User')
            v-list-item-content
              v-list-item-title {{ getName($keycloak.fullName) }}
        v-divider
        v-list
          v-list-item(@click="dialog = true")
            v-list-item-title Perfil do Usuário
          v-list-item(@click='logout')
            v-list-item-title Sair do Sistema

  v-container(fluid)
    v-layout(align-center justify-center row)
      v-flex(xs12 sm12 md8 lg8 xl8)
        v-list(two-line)
          template(v-for="(item, index) in items")
            v-list-item(v-if="item.link" :key="item.title" :to="item.link" v-show="$permission(item.permissions)")
              v-list-item-icon
                v-icon(size="40") {{item.avatar}}

              v-list-item-content
                v-list-item-title(v-html="item.title")
                v-list-item-subtitle(v-html="item.subtitle")

            v-list-item(v-else :key="item.title" :href="item.href" target="_blank" v-show="$permission(item.permissions)")
              v-list-item-icon
                v-icon(size="40") {{item.avatar}}

              v-list-item-content
                v-list-item-title(v-html="item.title")
                v-list-item-subtitle(v-html="item.subtitle")
                
            v-divider(inset :key="index" v-show="$permission(item.permissions)")

          //- Caso específico do SGI
          v-list-item(:href="getUrlSGI() + '?t=' + this.$keycloak.token" target="_blank" v-show="info.userSGI")
              v-list-item-icon
                v-icon(size="40") mdi-alpha-s-circle

              v-list-item-content
                v-list-item-title SGI
                v-list-item-subtitle Sistema de Gestão Integrada
                
          v-divider(inset key="divider_sgi" v-show="info.userSGI")
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      snackbar: {
        mensagem: "",
        visivel: false,
        cor: "",
        tempo: 3000
      },
      info: {
        nome_guerra: '',
        cpf: '',
        email: '',
        userSGI: false
      },
      senha_atual: '',
      nova_senha: '',
      nova_senha_confirmation: '',
      antigo_email: '',
      novo_email: '',
      novo_email_confirmation: '',
      menu: false,
      dialog: false,
      items: [
        {
          avatar: 'mdi-library-books',
          title: 'Boletins',
          subtitle: "Boletins gerais, internos e reservados.",
          link: '/boletins',
          permissions: ['public']
        }
      ]
    }
  },
  methods: {
    mensagemSucesso(mensagem) {
      this.snackbar.mensagem = mensagem
      this.snackbar.cor = "light-green darken-2"
      this.snackbar.visivel = true
    },
    mensagemError(mensagem) {
      this.snackbar.mensagem = mensagem
      this.snackbar.cor = "red darken-4"
      this.snackbar.visivel = true
    },
    mensagemInfo(mensagem) {
      this.snackbar.mensagem = mensagem
      this.snackbar.cor = "light-blue darken-4"
      this.snackbar.visivel = true
    },
    getUrlSGI() {
      return process.env['VUE_APP_URL_SGI'];
    },
    logout(){
      this.$keycloak.logoutFn()
    },
    getName(nome){
      let nomes = nome.split(' ')
      let distinct = nomes.filter(this.onlyUnique);
      return distinct.join(' ')
    },
    onlyUnique(value, index, self) { 
      return self.indexOf(value) === index;
    },
    async alterarSenha(){
      const api = this.$api('contas');

      try{
        const response = await api.put('alterar_senha', {
          senha_atual: this.senha_atual, 
          nova_senha: this.nova_senha, 
          nova_senha_confirmation: this.nova_senha_confirmation
        });

        this.mensagemSucesso("Senha alterada com sucesso");
        this.loading = false;
      }
      catch(error){
          let list = []
          let keys = Object.keys(error.response.data.errors)

          if (error.response.status == 422) {
            for (const campo of keys) {
              for (const mensagem of error.response.data.errors[campo]) {
                list.push(" - " + mensagem)
              }
            }
          }

          this.mensagemError(list.join("<br/>"))
      }
    },
    async alterarEmail(){
      const api = this.$api('contas');

      try{
        const response = await api.put('alterar_email', {
          antigo_email: this.antigo_email, 
          novo_email: this.novo_email, 
          novo_email_confirmation: this.novo_email_confirmation
        });

        this.mensagemSucesso("E-mail alterado com sucesso");
        this.infoUser();
        this.loading = false;
      }
      catch(error){
          let list = []
          let keys = Object.keys(error.response.data.errors)

          if (error.response.status == 422) {
            for (const campo of keys) {
              for (const mensagem of error.response.data.errors[campo]) {
                list.push(" - " + mensagem)
              }
            }
          }

          this.mensagemError(list.join("<br/>"))
      }
    },
    async infoUser(){
      const api = this.$api('contas');

    try{
        const response = await api.get('info');

        this.info.nome_guerra = response.data.nome;
        this.info.cpf =  response.data.cpf;
        this.info.email = response.data.email;
        this.info.userSGI = response.data.userSgi;
      }
      catch(error){
        // this.mensagemError('Houve um erro ao tentar recuperar dados do usuário');
      }
    }
  },
  mounted(){
    this.infoUser();
  }
}
</script>
